import _Promise from "@babel/runtime-corejs3/core-js-stable/promise";
export function defaultExceptionHandler(err) {
  return _Promise.reject(err.message);
}